// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
/* eslint-disable */
export const VERSION = {
    "dirty": false,
    "raw": "5032593",
    "hash": "5032593",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "5032593",
    "semverString": null,
    "version": "0.0.1"
};
/* tslint:enable */
